const MYSHOPIFY_SUFFIX = '.myshopify.com';
const HANDLE_RE = /^[a-z0-9][a-z0-9-]*$/i;

/** Shopify admin root for a store (`https://admin.shopify.com/store/<handle>`); null when the domain is unknown or malformed. */
export function shopifyAdminBase(shopDomain?: string | null): string | null {
  const host = (shopDomain ?? '').trim().toLowerCase();
  const handle = host.endsWith(MYSHOPIFY_SUFFIX) ? host.slice(0, -MYSHOPIFY_SUFFIX.length) : host;
  return HANDLE_RE.test(handle) ? `https://admin.shopify.com/store/${handle}` : null;
}

/** Shopify admin orders list filtered to one discount code; null when the store or code is unknown. */
export function shopifyOrdersUrl(shopDomain?: string | null, code?: string | null): string | null {
  const base = shopifyAdminBase(shopDomain);
  if (!base || !code) return null;
  return `${base}/orders?query=${encodeURIComponent(`discount_code:${code}`)}`;
}

/** Shopify admin discounts list; null when the store is unknown. */
export function shopifyDiscountsUrl(shopDomain?: string | null): string | null {
  const base = shopifyAdminBase(shopDomain);
  return base ? `${base}/discounts` : null;
}

/** One discount's admin page from its `gid://shopify/DiscountNode/<n>` id; null when either is unknown. */
export function shopifyDiscountUrl(shopDomain?: string | null, gid?: string | null): string | null {
  const base = shopifyAdminBase(shopDomain);
  const numericId = /(\d+)$/.exec(gid ?? '')?.[1];
  return base && numericId ? `${base}/discounts/${numericId}` : null;
}
